import { useCallback } from "react";

type Props = {
  value: number;
  onChange: (n: number) => void;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
};

export function NumberInput({
  value,
  onChange,
  min,
  max,
  step = 1,
  placeholder,
}: Props) {
  const clamp = useCallback(
    (n: number) => {
      if (min !== undefined && n < min) return min;
      if (max !== undefined && n > max) return max;
      return n;
    },
    [min, max],
  );

  const handleDec = () => onChange(clamp(value - step));
  const handleInc = () => onChange(clamp(value + step));
  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (raw === "") {
      onChange(0);
      return;
    }
    const n = Number(raw);
    if (Number.isFinite(n)) onChange(clamp(n));
  };

  const decDisabled = min !== undefined && value <= min;
  const incDisabled = max !== undefined && value >= max;

  return (
    <div className="number-input">
      <button
        type="button"
        className="number-input-btn"
        onClick={handleDec}
        disabled={decDisabled}
        aria-label="Уменьшить"
      >
        −
      </button>
      <input
        type="text"
        inputMode="numeric"
        className="number-input-value"
        value={value}
        onChange={handleInput}
        placeholder={placeholder}
      />
      <button
        type="button"
        className="number-input-btn"
        onClick={handleInc}
        disabled={incDisabled}
        aria-label="Увеличить"
      >
        +
      </button>
    </div>
  );
}
